import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function MethodSection() {
  return <section className="bg-navy-dark text-white py-24 px-4 relative overflow-hidden" data-id="element-175">
      <div className="absolute top-0 right-0 w-64 h-64 bg-sky/10 rounded-full blur-3xl" data-id="element-176"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-lavender/10 rounded-full blur-3xl" data-id="element-177"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-178">
        <div className="text-center mb-16" data-id="element-179">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full text-sm font-semibold mb-6 text-sky-light" data-id="element-180">
            <BookOpen size={16} data-id="element-181" /> El sistema completo de sueño infantil
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-8" data-id="element-182">
            Presentamos el Método Noches de Paz™
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-3xl mx-auto space-y-4 text-lg md:text-xl text-white/80" data-id="element-183">
            <p data-id="element-184">
              Un sistema completo en formato PDF diseñado para madres y padres
              de bebés de 4 a 24 meses que necesitan claridad, no más teoría.
            </p>
            <div className="flex flex-wrap justify-center gap-4 py-6" data-id="element-185">
              <span className="bg-red-500/20 text-red-200 px-4 py-2 rounded-lg font-medium" data-id="element-186">
                ❌ No es un método de "dejar llorar".
              </span>
              <span className="bg-red-500/20 text-red-200 px-4 py-2 rounded-lg font-medium" data-id="element-187">
                ❌ No te pide que abandones a tu bebé.
              </span>
              <span className="bg-red-500/20 text-red-200 px-4 py-2 rounded-lg font-medium" data-id="element-188">
                ❌ No ignora el vínculo ni el apego.
              </span>
            </div>
            <p className="font-semibold text-white text-xl" data-id="element-189">
              Es un sistema paso a paso que te enseña exactamente qué está
              pasando en el sueño de tu bebé, qué errores invisibles lo sabotean
              y cómo construir una rutina que funcione desde las primeras
              noches.
            </p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mt-16" data-id="element-190">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-191">
            <a href="#compra" className="block cursor-pointer group" data-id="element-192">
              <img src="https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=600&q=80" alt="Método Noches de Paz" className="rounded-2xl shadow-2xl w-full object-cover aspect-[4/3] group-hover:scale-105 transition-transform duration-500" data-id="element-193" />
            </a>
          </motion.div>

          <div className="space-y-8" data-id="element-194">
            <h3 className="text-2xl font-bold text-gold mb-6" data-id="element-195">
              CÓMO FUNCIONA EN 3 PASOS
            </h3>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="flex gap-4" data-id="element-196">
              <div className="flex-shrink-0 w-12 h-12 bg-sky rounded-full flex items-center justify-center text-navy font-bold text-xl" data-id="element-197">
                1
              </div>
              <div data-id="element-198">
                <h4 className="text-xl font-bold mb-2" data-id="element-199">PASO 1: ENTENDÉS</h4>
                <p className="text-white/70" data-id="element-200">
                  Aprendés cómo funciona realmente el sueño de tu bebé y por qué
                  está pasando lo que está pasando.
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="flex gap-4" data-id="element-201">
              <div className="flex-shrink-0 w-12 h-12 bg-sky rounded-full flex items-center justify-center text-navy font-bold text-xl" data-id="element-202">
                2
              </div>
              <div data-id="element-203">
                <h4 className="text-xl font-bold mb-2" data-id="element-204">PASO 2: APLICÁS</h4>
                <p className="text-white/70" data-id="element-205">
                  Seguís el plan paso a paso con herramientas concretas para
                  cada situación.
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex gap-4" data-id="element-206">
              <div className="flex-shrink-0 w-12 h-12 bg-sky rounded-full flex items-center justify-center text-navy font-bold text-xl" data-id="element-207">
                3
              </div>
              <div data-id="element-208">
                <h4 className="text-xl font-bold mb-2" data-id="element-209">PASO 3: VES CAMBIOS</h4>
                <p className="text-white/70" data-id="element-210">
                  Empezás a notar diferencias reales desde las primeras noches
                  de implementación.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}